import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_PROJECT = createActionType("ADD_PROJECT");
export const GET_PROJECTS = createActionType("GET_PROJECTS");
export const GET_PROJECT_BY_ID = createActionType("GET_PROJECT_BY_ID");
export const EDIT_PROJECT = createActionType("EDIT_PROJECT");
export const REMOVE_PROJECT = createActionType("REMOVE_PROJECT");

export const addProject = (data: any) =>
  createAsyncAction(ADD_PROJECT, "/project/add_project", "post", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const getProjects = () =>
  createAsyncAction(
    GET_PROJECTS,
    "/project/get_all_projects/cpanel",
    "get",
    undefined
  );

export const getProjectById = (id: string) =>
  createAsyncAction(
    GET_PROJECT_BY_ID,
    `/project/get_project_by_id/${id}`,
    "get",
    undefined
  );

export const editProject = (id: any, data: any) =>
  createAsyncAction(
    EDIT_PROJECT,
    `/project/edit_project_by_id/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeProject = (id: any) =>
  createAsyncAction(
    REMOVE_PROJECT,
    `/project/remove_project_by_id/${id}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
